import { combineReducers, } from 'redux';
import attributesReducer, { productsAttributesSaga, } from './attributes';
import productsReducer, { productsSaga, } from './collection';

export { productsAttributesOperations, } from './attributes';
export { productsOperations, } from './collection';

export default {
    reducers: combineReducers({
        attributes: attributesReducer,
        collection: productsReducer,
    }),

    sagas: {
        productsAttributesSaga: productsAttributesSaga,
        collectionSaga: productsSaga,
    }
};
